import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, message, Select, Tag } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.scss";
import UploadAgreement from "@/components/UploadAgreement";
const { Option } = Select;
const { TextArea } = Input;

const PublishVideo = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [selectedTag, setSelectedTag] = useState("1");
  const [datadTag, setSelectedDataTag] = useState("1");
  const [fileUnit, setfileUnit] = useState("KB");
  const [dataDetail, setDatali] = useState({});
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选
  const handleTagClick = (tag) => {
    if (selectedTag !== tag.key) {
      setSelectedTag(tag.key);
    }
  };
  const handleDataTagClick = (tag) => {
    if (datadTag !== tag.key) {
      setSelectedDataTag(tag.key);
    }
  };

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `dataSet/account/detail?dataSetId=${id}`
      );
      setDatali(response.data.data);
      // setdataSource(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    }
  }, [itemId]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次

  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        ...dataDetail,
      });

      setfileUnit(dataDetail.fileUnit);
      setSelectedTag(dataDetail.fileType + "");
      setSelectedDataTag(dataDetail.dataType + "");
    }
  }, [dataDetail, form]); // 依赖dataDetail和form，以便在它们变化时重新运行

  const onFinish = (values) => {
    console.log(values);
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("introduction", values.introduction);
    formData.append("fileSize", values.fileSize);
    formData.append("fileUnit", fileUnit);
    formData.append("fileType", selectedTag);
    formData.append("dataType", datadTag);
    formData.append("price", values.price);
    let url = "/dataSet/account/save";

    if (itemId) {
      formData.append("datasetIdArray", itemId);
      url = "/dataSet/account/update";
    }
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            message.success("保存成功");
            form.resetFields();
            navigate("/personal?selectedKey=5&openKeys=sub2&openKeys=sub1");
          } else {
            message.error("保存失败");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const fileOptions = [
    { key: "1", value: "压缩文件" },
    { key: "2", value: "图片文件 " },
    { key: "3", value: "音视频文件" },
    { key: "4", value: "应用程序" },
    { key: "5", value: "PDF文档" },
    { key: "6", value: "Word文档" },
    { key: "11", value: "Excel工作表" },
    { key: "22", value: "PPT幻灯片 " },
    { key: "33", value: "Flash影片" },
    { key: "44", value: "CHM文件" },
    { key: "55", value: "帮助文件" },
    { key: "66", value: "其他文件" },
  ].map((tag) => (
    <Tag
      color={selectedTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const dataOptions = [
    { key: "1", value: "人物形态" },
    { key: "2", value: "自然语言处理 " },
    { key: "3", value: "时尚艺术" },
    { key: "4", value: "图像识别" },
    { key: "5", value: "语音识别" },
    { key: "6", value: "机器翻译" },
    { key: "11", value: "姿态评估" },
    { key: "22", value: "自动驾驶 " },
    { key: "33", value: "农业农艺" },
    { key: "44", value: "工业制造" },
    { key: "55", value: "动物识别" },
    { key: "66", value: "无人机" },
    { key: "111", value: "机器人" },
    { key: "222", value: "文本检测 " },
    { key: "333", value: "智能硬件" },
    { key: "444", value: "智能零售" },
    { key: "555", value: "智慧城市" },
    { key: "666", value: "植物" },
    { key: "1111", value: "卫星遥感" },
  ].map((tag) => (
    <Tag
      color={datadTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleDataTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const changeSize = (v) => {
    setfileUnit(v);
  };

  const selectAfter = (
    <Select
      value={fileUnit}
      style={{
        width: 60,
      }}
      onChange={changeSize}
    >
      <Option value="KB">KB</Option>
      <Option value="MB">MB</Option>
      <Option value="TB">TB</Option>
    </Select>
  );
  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=5&openKeys=sub2&openKeys=sub1");
  };
  const initialValues = {
    price: 100,
    fileSize: 100,
  };
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="dataset_form"
      initialValues={initialValues} // 设置初始值
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="标题"
        name="title"
        rules={[{ required: true, message: "请输入标题!" }]}
      >
        <Input showCount maxLength={200} />
      </Form.Item>
      <Form.Item
        label="简介"
        name="introduction"
        rules={[{ required: true, message: "请输入简介!" }]}
      >
        <TextArea
          showCount
          style={{
            height: 200,
            resize: "none",
          }}
          maxLength={200}
        />
      </Form.Item>
      <Form.Item
        label="文件大小"
        name="fileSize"
        rules={[{ required: true, message: "必填" }]}
      >
        <InputNumber addonAfter={selectAfter} />
      </Form.Item>
      <Form.Item label="文件类型" name="fileType">
        <div>{fileOptions}</div>
      </Form.Item>

      <Form.Item label="数据类型" name="dataType">
        <div>{dataOptions}</div>
      </Form.Item>
      <Form.Item
        label="价格（元）"
        name="price"
        rules={[{ required: true, message: "必填" }]}
      >
        <InputNumber />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishVideo;
